import { Form, Modal, Select } from "antd";
import { useEffect } from "react";
import { useStaffList, useUpdateStaff } from "@/modules/staff/hooks/useStaff";
import type { Brigade } from "../types";

interface BrigadeAssignStaffModalProps {
	brigade: Brigade | null;
	open: boolean;
	onClose: () => void;
}

export function BrigadeAssignStaffModal({ brigade, open, onClose }: BrigadeAssignStaffModalProps) {
	const [form] = Form.useForm<{ staffId: string }>();
	const { data: staffData } = useStaffList({
		organizationId: brigade?.organizationId ?? "",
		page: 1,
		limit: 100,
	});
	// Faqat employee va brigadir brigadaga tegishli bo'la oladi (backend shart qiladi).
	// EMPLOYEE har doim biror brigadaga biriktirilgan bo'ladi — shuning uchun bu yerda
	// "bo'sh" emas, balki BOSHQA brigadadagi xodim/brigadirni shu brigadaga o'tkazish
	// uchun ro'yxat ko'rsatiladi.
	const staffItems = (staffData?.data?.items ?? []).filter(
		(s) =>
			(s.staffType === "EMPLOYEE" || s.staffType === "BRIGADIER") && s.brigadeId !== brigade?.id
	);
	const { mutate: updateStaff, isPending } = useUpdateStaff();

	useEffect(() => {
		if (open) {
			form.resetFields();
		}
	}, [open, form]);

	const handleClose = () => {
		onClose();
		form.resetFields();
	};

	const handleSubmit = () => {
		form.validateFields().then((values) => {
			if (!brigade) {
				return;
			}
			updateStaff(
				{ id: values.staffId, data: { brigadeId: brigade.id } },
				{ onSuccess: handleClose }
			);
		});
	};

	return (
		<Modal
			title={brigade ? `"${brigade.name}" brigadasiga xodim biriktirish` : "Xodim biriktirish"}
			open={open}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isPending}
			okText="Biriktirish"
			cancelText="Bekor qilish"
			destroyOnHidden
			width={480}
		>
			<Form form={form} layout="vertical" requiredMark={false} className="mt-4">
				<Form.Item
					name="staffId"
					label="Xodim"
					rules={[{ required: true, message: "Xodimni tanlang" }]}
				>
					<Select
						placeholder="Xodimni tanlang"
						showSearch
						notFoundContent="Biriktirish uchun xodim topilmadi"
						filterOption={(input, option) =>
							(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
						}
						options={staffItems.map((s) => {
							const role = s.staffType === "BRIGADIER" ? " (brigadir)" : "";
							const current = s.brigade ? ` — hozir: ${s.brigade.name}` : "";
							return { value: s.id, label: `${s.fullname}${role}${current}` };
						})}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
}
